import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    
   
    {
      name: "Application Development & Tech Engineer",
      desc: "Experience innovation through our specialized App Engineering and Development Service focused on React applications. I craft dynamic, high-performance user interfaces using JavaScript and TypeScript, seamlessly integrating with APIs to deliver scalable and efficient solutions. By incorporating Python for targeted data analysis, I provide valuable insights that enhance app functionality and user experience. With a strong emphasis on agile development, clean code, and scalability, I bring your digital vision to life—empowering your business to thrive in a competitive, fast-paced landscape.",
      icon: "fa-solid fa-microchip",
    },
    {
      name: "Business Growth and Strategy Consulting",
      desc: "Transform your organization's revenue trajectory with our Strategic Revenue Growth Consulting Service. Drawing on extensive experience and a process-oriented mindset, we develop tailored strategies for sustained long-term success. From market analysis and product optimization to technology integration and operational efficiency, my service covers the full spectrum of revenue enhancement. With a focus on customer satisfaction, strategic collaborations, and financial management, i provide a holistic approach to drive your organization's growth.",
      icon: "fa-solid fa-chart-line",
    },
   
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
